import { faHardHat } from "@fortawesome/free-solid-svg-icons";
import React, { type FC } from "react";
import { ContentContainer } from "../../components/content/ContentContainer";
import { PageHeader } from "../../components/content/PageHeader";
import { SettingsSearch } from "../../components/content/SettingsSearch";

export const DashboardsOverviewPage: FC = () => {
  return (
    <ContentContainer size={"md"}>
      <PageHeader>Dashboards</PageHeader>
      <SettingsSearch
        tiles={[
          {
            icon: faHardHat,
            title: "Management Dashboard",
            subTitle: "Werkplekinspectie Hijswerkzaamheden",
            href: `/dashboards/workstation-inspepctions`,
          },
        ]}
      />
    </ContentContainer>
  );
};
